import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Locations } from './pages/locations/locations';
import { Floors } from './pages/floors/floors';
import { Apply } from './pages/apply/apply';
import { Faq } from './pages/faq/faq';
import { Login } from './pages/admin/login';
import { authGuard } from './guards/auth';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'index', redirectTo: '', pathMatch: 'full' },
  { path: 'locations', component: Locations },
  { path: 'floors', component: Floors },
  { path: 'apply', component: Apply },
  { path: 'faq', component: Faq },
  { path: 'login', component: Login },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin').then(m => m.Admin),
    canActivate: [authGuard]
  },
  { path: '**', redirectTo: '' }
];
